<template>
  <v-container>
    <v-card>
      <v-card-title>
        <h1>Create a New AI Use Case Request</h1>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-text-field
            v-model="request.title"
            :rules="[v => !!v || 'Title is required']"
            label="Use Case Title"
            required
          ></v-text-field>
          <v-textarea
            v-model="request.description"
            :rules="[v => !!v || 'Description is required']"
            label="Detailed Description"
            required
          ></v-textarea>
          <v-textarea
            v-model="request.justification"
            :rules="[v => !!v || 'Justification is required']"
            label="Justification (e.g., business value, efficiency improvements)"
            required
          ></v-textarea>
          <v-text-field
            v-model="request.department"
            :rules="[v => !!v || 'Department is required']"
            label="Requesting Department"
            required
          ></v-text-field>
          <v-text-field
            v-model="request.contact"
            :rules="[v => !!v || 'Contact person is required']"
            label="Contact Person (email)"
            required
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="submitRequest" :disabled="!valid || loading">
          <span v-if="!loading">Submit Request</span>
          <v-progress-circular v-else indeterminate size="24"></v-progress-circular>
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="6000">
      {{ snackbar.message }}
    </v-snackbar>
  </v-container>
</template>

<script>
import { getFirestore, collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { auth } from '@/firebase/init';

export default {
  name: 'CreateRequest',
  data() {
    return {
      valid: false,
      loading: false,
      request: {
        title: '',
        description: '',
        justification: '',
        department: '',
        contact: '',
      },
      snackbar: {
        show: false,
        message: '',
        color: '',
      },
    };
  },
  methods: {
    async submitRequest() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          const db = getFirestore();
          const user = auth.currentUser;

          if (!user) {
            throw new Error('You must be logged in to submit a request.');
          }

          await addDoc(collection(db, 'useCaseRequests'), {
            ...this.request,
            status: 'pending',
            requester: user.email,
            createdAt: serverTimestamp(),
          });

          this.snackbar.message = 'Request submitted successfully!';
          this.snackbar.color = 'success';
          this.$refs.form.reset();
        } catch (error) {
          console.error('Error submitting request:', error);
          this.snackbar.message = 'Error submitting request. Please try again.';
          this.snackbar.color = 'error';
        } finally {
          this.loading = false;
          this.snackbar.show = true;
        }
      }
    },
  },
};
</script>

<style lang="scss">
</style> 